import { useEffect, useRef } from "react";
import { createContext } from "react";

import AppRouter from "app/router";
import { Loader } from "components/atoms/loader/Loader";
import { StepperComponent } from "components/molecules";
import CartErrorBanner from "components/molecules/cart-error-banner/CartErrorBanner";
import ErrorBoundary from "components/molecules/error-boundary/ErrorBoundary";
import {
  useAffiliateId,
  useCurrency,
  useSyncStoreData,
  useTracking,
} from "hooks";
import { useStoreActions, useStoreState } from "store/store";

import "app/axios";
import "./App.css";

export const RefContext = createContext<HTMLDivElement | null>(null);

export const modalRoot =
  document.getElementById("modal-root") ??
  (() => {
    const el = document.createElement("div");
    el.id = "modal-root";
    document.body.appendChild(el);
    return el;
  })();

function App() {
  // actions
  const getAddonsThunk = useStoreActions((a) => a.getAddonsThunk);
  // state
  const selectedCar = useStoreState((s) => s.selectedCar);

  const { currency } = useCurrency();

  const appWrapperRef = useRef<HTMLDivElement | null>(null);

  useSyncStoreData();
  useAffiliateId();
  useTracking();

  useEffect(() => {
    if (!selectedCar?.vehicleId) return;
    getAddonsThunk({ vehicle_id: selectedCar.vehicleId });
  }, [getAddonsThunk, selectedCar?.vehicleId, currency]);

  return (
    <div ref={appWrapperRef}>
      <RefContext.Provider value={appWrapperRef.current}>
        <StepperComponent />
        <CartErrorBanner />
        {/* Narrower net: a crash inside one step is contained here, so the
            surrounding chrome survives and the recovery card renders in place
            of just that step rather than the whole widget. */}
        <ErrorBoundary scope="router">
          <AppRouter />
        </ErrorBoundary>
      </RefContext.Provider>
      <Loader />
    </div>
  );
}

export default App;
